// extracted by mini-css-extract-plugin
export default {"NumberCallPopupContainer":"numberCallPopup_NumberCallPopupContainer__u7fJS","NumberCallPopupArrow":"numberCallPopup_NumberCallPopupArrow__5pfG8"};